import React, { useState, useEffect } from 'react'
import { AppBar, Box, Toolbar } from '@mui/material'
import { Link, useLocation } from 'react-router-dom'
import makeStyles from '@mui/styles/makeStyles'
import Container from '@mui/material/Container'

export const LINKS = {
  NL_Pathologist: [
    {
      title: 'Inbox',
      to: '/case-worklist',
    },
    {
      title: 'Search Case',
      to: '/search',
    },
    {
      title: 'Calendar',
      to: '/calendar',
    },
  ],
  NL_LabManager: [
    {
      title: 'Inbox',
      to: '/lab-manager',
    },
    {
      title: 'Search Case',
      to: '/search',
    },
    {
      title: 'Pathologist Calendar',
      to: '/admin-calendar',
    },
    {
      title: 'Users',
      to: '/manager-options',
    },
    {
      title: 'Reports',
      to: '/load-reports',
    },
  ],
  NL_WOMA_ADMIN: [
    {
      title: 'Inbox',
      to: '/it-admin',
    },
    {
      title: 'Search Case',
      to: '/search',
    },
    {
      title: 'Pathologist Calendar',
      to: '/admin-calendar',
    },
    {
      title: 'Manage Users',
      to: '/manager-options',
    },
    {
      title: 'Reports',
      to: '/load-reports',
    },
    {
      title: 'Settings',
      to: '/settings',
    },
  ],
  NL_SpecimenLogistics: [
    {
      title: 'Inbox',
      to: '/logistics',
    },
    {
      title: 'Search Case',
      to: '/search',
    },
    {
      title: 'Pathologist Calendar',
      to: '/admin-calendar',
    },
    {
      title: 'Manage Users',
      to: '/manager-options',
    },
    {
      title: 'Reports',
      to: '/load-reports',
    },
  ],
}

const useStyles = makeStyles((theme) => ({
  appBar: {
    color: '#0A688D',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  navlinks: {
    marginLeft: theme.spacing(2),
    display: 'flex',
  },
  link: {
    textDecoration: 'none',
    color: '#0A688D',
    fontSize: '16px',
    marginLeft: '70px',
    padding: '2px 3px',
    '&:first-child': {
      marginLeft: '0',
    },
    '&:hover': {
      backgroundColor: 'rgba(10, 104, 141, 0)',
      borderBottom: '3px solid rgba(10, 104, 141, 1)',
    },
    '&.active': {
      borderBottom: '3px solid rgba(10, 104, 141, 1)',
    },
  },
}))

export function Navbar({ role, user }): JSX.Element | null {
  const classes = useStyles()
  //[Note] : the initial value can be set depending on the location selected
  const location = useLocation()

  const [selectedLink, setSelectedLink] = useState('')

  useEffect(() => {
    const navLink = LINKS[role].find((link) => link.to === location.pathname)

    const splitUrl = window.location.pathname.split('/')

    if (!navLink && splitUrl[2] !== 'add-user-account') {
      setSelectedLink('Inbox')
    } else if (splitUrl[2] == 'add-user-account') {
      setSelectedLink('Manage Users')
    } else {
      setSelectedLink(navLink.title)
    }
  }, [location, role])

  const getClassNames = (linkName) => `${classes.link} ${selectedLink == linkName ? 'active' : ''}`

  const navLinks = LINKS[role]

  const onSelectTab = (val) => {
    setSelectedLink(val)
  }

  return (
    <Box>
      <AppBar position="static" className={classes.appBar}>
        <Toolbar>
          <Container className="WP_Navbar">
            {navLinks.map((item) => (
              <Link
                to={item.to}
                key={item.title}
                className={getClassNames(item.title)}
                onClick={() => onSelectTab(item.title)}
              >
                {item.title}
              </Link>
            ))}
          </Container>
        </Toolbar>
      </AppBar>
    </Box>
  )
}
